import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { LoginUserRequestModel } from 'src/app/models/request/login-user-request.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {

  constructor(private _httpClient: HttpClient) { }

  loginUser(loginUserModel: LoginUserRequestModel): Observable<string> {
    return this._httpClient.post<string>(`${environment.apiCervinoBackend}${enpointCervinoWeb.login.LoginUser}`,
      loginUserModel
    );
  }

  logoutUser() {
    let token = new ItemFilterModel("token", null, null, localStorage.getItem(AuthenticationContants.keyTokenLocalStorage) || "")
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.login.LogoutUser}`, token);
  }
}